import React from 'react';

/**
 * Per Diem boolean display
 */
export const PerDiemTemplate: React.FC<{ isPerDiem: boolean }> = ({ isPerDiem }) => (
  <span>{isPerDiem ? 'Yes' : 'No'}</span>
);

// Template function for grid column
export const perDiemTemplate = (props: { isPerDiem: boolean }) => (
  <PerDiemTemplate isPerDiem={props.isPerDiem} />
);

export default PerDiemTemplate;
